import OfficeHours from './office-hours';

export default OfficeHours;
